// src/components/Common/BannerCarousel.jsx
import React, { useRef } from 'react';

const BannerCarousel = ({ banners }) => {
  const bannerContainerRef = useRef(null);

  const scrollBanners = (direction) => {
    const container = bannerContainerRef.current;
    if (container) {
      const scrollAmount = container.offsetWidth;
      container.scrollTo({
        left: container.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount),
        behavior: 'smooth'
      });
    }
  };

  const handleBannerClick = (url) => {
    if (url) {
      window.location.href = url;
    }
  };

  if (!banners || banners.length === 0) return null;

  return (
    <div className="relative mb-6 md:mb-8 group w-full pt-4 md:pt-6">
      <style>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none !important;
        }
        .hide-scrollbar {
          -ms-overflow-style: none !important;
          scrollbar-width: none !important;
        }
      `}</style>
      
      <button
        onClick={() => scrollBanners('left')}
        className="hidden md:flex absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 border border-gray-200 z-10 items-center justify-center text-gray-700 shadow-md hover:bg-white transition-all opacity-0 group-hover:opacity-100"
      >
        <i className="fas fa-chevron-left"></i>
      </button>
      
      <div
        className="flex gap-3 md:gap-5 overflow-x-auto scroll-smooth w-full snap-x snap-mandatory pb-2 hide-scrollbar"
        ref={bannerContainerRef}
      >
        {banners.map((banner) => (
          <div
            key={banner.id}
            onClick={() => handleBannerClick(banner.redirectUrl)}
            // Removed bg-blend-overlay to keep the image exactly as it is without color tinting
            className="flex-shrink-0 w-[90%] md:w-[calc(33.333%-13px)] snap-center rounded-2xl p-5 md:p-6 text-white relative overflow-hidden transition-transform hover:-translate-y-1 cursor-pointer min-h-[160px] md:min-h-[180px] flex flex-col justify-between shadow-sm md:shadow-md bg-cover bg-center"
            style={{
              backgroundColor: banner.bgColor || '#0F2F63',
              backgroundImage: `url(${banner.image})`
            }}
          >
            <div className="relative z-10">
              {banner.tag && (
                <span className="inline-block bg-white/20 backdrop-blur-md px-2.5 py-0.5 md:px-3 md:py-1 rounded-full text-[10px] md:text-xs font-bold mb-2 tracking-wide">
                  {banner.tag}
                </span>
              )}
              {/* Added drop-shadow so text remains readable over bright images */}
              {banner.title && <div className="text-xl md:text-2xl font-black leading-tight mb-1 drop-shadow-md">{banner.title}</div>}
              {banner.subtitle && <div className="text-sm md:text-base font-bold opacity-95 mb-1 drop-shadow-md">{banner.subtitle}</div>}
              {banner.offer && <div className="text-xs md:text-sm font-medium opacity-90 drop-shadow-md">{banner.offer}</div>}
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={() => scrollBanners('right')}
        className="hidden md:flex absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 border border-gray-200 z-10 items-center justify-center text-gray-700 shadow-md hover:bg-white transition-all opacity-0 group-hover:opacity-100"
      >
        <i className="fas fa-chevron-right"></i>
      </button>
    </div>
  );
};

export default BannerCarousel;